import ConversationAPI from '../../api/conversations';

export const state = {
  inboxes: {},
  labels: {},
  totalInboxes: {},
  totalLabels: {},
};

export const getters = {
  getInboxOpenCount: $state => inboxId => $state.inboxes[String(inboxId)] || 0,
  getLabelOpenCount: $state => labelId => $state.labels[String(labelId)] || 0,
  getInboxCount: $state => inboxId => $state.totalInboxes[String(inboxId)] || 0,
  getLabelCount: $state => labelId => $state.totalLabels[String(labelId)] || 0,
};

export const mutations = {
  SET_OPEN_COUNTS(
    $state,
    { inboxes = {}, labels = {}, total_inboxes = {}, total_labels = {} }
  ) {
    $state.inboxes = inboxes;
    $state.labels = labels;
    $state.totalInboxes = total_inboxes;
    $state.totalLabels = total_labels;
  },
};

export const actions = {
  async get({ commit }) {
    try {
      const { data } = await ConversationAPI.getOpenCounts();
      commit('SET_OPEN_COUNTS', data.payload || {});
    } catch {
      // Fail silently — counts are informational only
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
